import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    userInfo: null,
    token: ''
  },
  getters: {
    isLoggedIn: state => state.isLoggedIn,
    userInfo: state => state.userInfo,
    token: state => state.token
  },
  mutations: {
    setLoginState(state, isLoggedIn) {
      state.isLoggedIn = isLoggedIn;
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setToken(state, token) {
      state.token = token;
    },
    logout(state) {
      state.isLoggedIn = false;
      state.userInfo = null;
      state.token = '';
    }
  },
  actions: {
  login({ commit }, { userInfo, token }) {
    commit('setLoginState', true);
    commit('setUserInfo', userInfo);
    commit('setToken', token);

    localStorage.setItem('token', token);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  logout({ commit }) {
    commit('logout');
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
  },
  async checkLoginStatus({ commit }) {
    const token = localStorage.getItem('token');
    const userInfo = localStorage.getItem('userInfo');

    if (token && userInfo) {
      commit('setLoginState', true);
      commit('setUserInfo', JSON.parse(userInfo));
      commit('setToken', token);
      return true;
    } else {
      commit('logout');
      return false;
    }
  }
},
  modules: {
  }
})
